import React, { useEffect } from 'react';
import StudentForm from './StudentForm';
import 'font-awesome/css/font-awesome.min.css';
import './App.css';

function App() {
  // **สำคัญ:** ให้แทนที่ด้วย URL ของ Google Apps Script Web App ที่คุณ Deploy ไว้
  const GOOGLE_APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzmxp9SAAvrB9PHTDqecBCitulQ4AzNjytvCAv8wngabZmbSaqxvSF6c6nqDUkHKj-4/exec';
  //const GOOGLE_APPS_SCRIPT_URL_NEW = 'https://script.google.com/macros/s/AKfycbze2_j3FxJ7khLv4RiBhtgl2TYRI9th-SShoyaV4vuckYB_F9JfDEwMqrrgEdYpOWcf/exec';

  // เพิ่ม: Redirect ไปยัง HTTPS เมื่ออยู่ใน production mode
  useEffect(() => {
    // บังคับใช้ HTTPS ใน production environment
    if (process.env.NODE_ENV === 'production' && 
        window.location.protocol !== 'https:') {
      window.location.href = `https://${window.location.host}${window.location.pathname}`;
    }
  }, []);

  // ตรวจสอบว่า URL ยังเป็นค่าเริ่มต้นหรือไม่
  const isDefaultUrl = GOOGLE_APPS_SCRIPT_URL === ' https://script.google.com/macros/s/AKfycbze2_j3FxJ7khLv4RiBhtgl2TYRI9th-SShoyaV4vuckYB_F9JfDEwMqrrgEdYpOWcf/exec' || 
                       GOOGLE_APPS_SCRIPT_URL === '' || 
                       GOOGLE_APPS_SCRIPT_URL === 'YOUR_GOOGLE_APPS_SCRIPT_URL_HERE'; 

   /* const isDefaultUrl = GOOGLE_APPS_SCRIPT_URL === ' https://script.google.com/macros/s/AKfycbxBXoz_kvqVOwDnFBABIpcJOpS5s9DIVuzX1nfYW4U1q1Fe5CUIDCew0jN-rpg9va9mbw/exec' || 
                       GOOGLE_APPS_SCRIPT_URL === '' || 
                       GOOGLE_APPS_SCRIPT_URL === 'YOUR_GOOGLE_APPS_SCRIPT_URL_HERE'; */
                       

  if (isDefaultUrl) {
    return (
      <div style={{ 
        padding: '20px', 
        backgroundColor: '#fff3cd', 
        border: '1px solid #ffc107',
        borderRadius: '8px',
        margin: '20px',
        fontFamily: 'Arial, sans-serif'
      }}>
        <h2 style={{ color: '#856404' }}>⚠️ กรุณาตั้งค่า Google Apps Script URL</h2>
        <p style={{ color: '#856404' }}>
          เปิดไฟล์ <code style={{ backgroundColor: '#f8f9fa', padding: '2px 4px', borderRadius: '4px' }}>src/App.js</code> 
          และแก้ไขตัวแปร <code style={{ backgroundColor: '#f8f9fa', padding: '2px 4px', borderRadius: '4px' }}>GOOGLE_APPS_SCRIPT_URL</code> 
          ให้เป็น URL ที่ถูกต้องที่คุณได้จากการ Deploy Google Apps Script Web App
        </p>
        <div style={{ 
          backgroundColor: '#f8f9fa', 
          padding: '10px', 
          borderRadius: '4px', 
          marginTop: '10px',
          border: '1px solid #dee2e6'
        }}>
          <strong>ขั้นตอนการตั้งค่า:</strong>
          <ol>
            <li>สร้าง Google Apps Script</li>
            <li>Deploy เป็น Web App</li>
            <li>คัดลอก URL ที่ได้</li>
            <li>นำมาใส่ในตัวแปร GOOGLE_APPS_SCRIPT_URL</li>
          </ol>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <main>
        <StudentForm googleAppsScriptUrl={GOOGLE_APPS_SCRIPT_URL} />
      </main>
    </div>
  );
}

export default App;